<template>
  <section>
    <v-card class="pa-3 mb-4">
      <v-row align="center">
        <v-col cols="12" sm="4">
          <v-select
            v-model="localMode"
            :items="modeOptions"
            item-text="text"
            item-value="value"
            :label="$t('listSelector.selectMode')"
            @change="emitModeChange"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="localItemsPerPage"
            :items="itemsPerPageOptions"
            :label="$t('listSelector.itemsPerPage')"
            @change="emitItemsPerPageChange"
          />
        </v-col>
        <v-col cols="12" sm="4" v-if="error">
          <v-alert type="error" dense>{{ error }}</v-alert>
        </v-col>
      </v-row>
    </v-card>

    <v-row>
      <!-- 已套用 -->
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <v-row class="align-center" no-gutters>
              <v-col cols="6" class="text-left">
                {{ modeLabel }}
              </v-col>
              <v-col cols="6" class="text-right">
                <v-btn
                  small
                  color="primary"
                  @click="$emit('apply-selected')"
                  :disabled="!localSelectedApplied.length"
                >
                {{ $t('listSelector.applySelected') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <br/>
          <v-card-text>
            <v-radio-group row 
              v-model="localAppliedSearchBy" 
              @change="onSearchByInput('applied', $event)"
              v-show="searchByOptions.length > 1">
              <template v-slot:label>
                <div>{{ $t('views.merchants.searchBy') }}<br></div>
              </template>
              <v-radio
                v-for="option in searchByOptions"
                :key="option.value"
                :label="option.text"
                :value="option.value"
              ></v-radio>
            </v-radio-group>
            <v-text-field
              :value="appliedSearch"
              :label="$t('listSelector.searchKeyword')"
              dense
              hide-details
              @input="onSearchInput('applied', $event)"
            />
            <v-data-table
              :headers="tableHeaders"
              :items="appliedList"
              item-key="id"
              show-select
              v-model="localSelectedApplied"
              :loading="loadingApplied"
              :server-items-length="appliedPagination.total"
              :page.sync="appliedPagination.page"
              :items-per-page="localItemsPerPage"
              hide-default-footer
              @update:page="fetchAppliedList"
              @input="onSelectedAppliedChange"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn icon @click="$emit('apply-one', item)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-data-table>

            <v-row class="d-flex align-center justify-space-between">
              <v-col cols="auto">
                <v-pagination
                  v-model="appliedPagination.page"
                  :length="appliedPageCount"
                  @input="fetchAppliedList"
                  :total-visible="5"
                />
              </v-col>
              <v-col cols="auto">
                <strong>{{$t('listSelector.total')}}:</strong>  {{ appliedPagination.total || 0 }}
              </v-col>
            </v-row>
            <v-row v-if="localSelectedApplied.length" class="d-flex align-center justify-space-between">
              <v-col cols="12">
                {{ $t('listSelector.selectedItems', { n: localSelectedApplied.length}) }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </section>
</template>

<script>
export default {
  props: {
    modeOptions: Array,
    defaultMode: String,
    modeLabel: String,
    error: String,
    tableHeaders: Array,

    appliedList: Array,
    // unappliedList: Array,
    selectedApplied: Array,
    // selectedUnapplied: Array,
    appliedPagination: Object,
    // unappliedPagination: Object,
    loadingApplied: Boolean,
    // loadingUnapplied: Boolean,
    appliedSearch: String,
    appliedSearchBy: String,
    // unappliedSearchBy: String,
    // unappliedSearch: String,
    searchByOptions: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultSearchBy: String,
    itemsPerPage: Number,
    itemsPerPageOptions: {
      type: Array,
      default() {
        return [10, 20, 30];
      }
    },
  },
  data() {
    return {
      debounceTimer: null,
      localMode: this.$props.defaultMode || "",
      localItemsPerPage: 10,
      localSelectedApplied: [],
      // localSelectedUnapplied: [],
      localAppliedSearchBy: "",
    };
  },
  computed: {
    appliedPageCount() {
      return Math.ceil(this.appliedPagination.total / this.localItemsPerPage);
    },
    // unappliedPageCount() {
    //   return Math.ceil(this.unappliedPagination.total / this.localItemsPerPage);
    // }
  },
  watch: {
    itemsPerPage: {
      immediate: true,
      handler(val) {
        this.localItemsPerPage = val;
      }
    },
    modeOptions: {
      immediate: true,
      handler() {
        this.localMode = this.$props.defaultMode ?? this.$props.modeOptions?.[0]?.value ?? '';
        this.emitModeChange();
      }
    },
    selectedApplied: {
      immediate: true,
      handler(val) {
        this.localSelectedApplied = [...val];
      }
    },
    // selectedUnapplied: {
    //   immediate: true,
    //   handler(val) {
    //     this.localSelectedUnapplied = [...val];
    //   }
    // },
    searchByOptions: {
      immediate: true,
      handler(options) {
        this.setInitialSearchByOptions()
      }
    }
  },
  methods: {
    emitModeChange() {
      console.log('emitModeChange');
      this.$emit("update:mode", this.localMode);
      // 當 mode 改變時，觸發重新評估 searchByOptions
      this.setInitialSearchByOptions();
      this.$emit("mode-changed");
      this.$emit('update:selectedApplied', []);
    },
    emitItemsPerPageChange() {
      console.log('emitItemsPerPageChange')
      this.$emit("update:itemsPerPage", this.localItemsPerPage);
      this.$emit("items-per-page-changed");
    },
    fetchAppliedList(page) {
      this.$emit("fetch-applied-list", page);
    },
    // fetchUnappliedList(page) {
    //   this.$emit("fetch-unapplied-list", page);
    // },
    onSearchInput(type, value) {
      console.log('onSearchInput')
      const eventName = `update:${type}Search`;
      const searchByKey = this.localAppliedSearchBy;
      
      this.$emit(eventName, {
        searchBy: value?.trim() ? searchByKey : '', // 有關鍵字時才回傳searchBy
        keyword: value?.trim()
      });

      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        const fetchFn = this.fetchAppliedList ;
        fetchFn(1); // 重設為第一頁
      }, 300);
    },
    onSearchByInput(type, value) {
      const eventName = `update:${type}Search`;
      const searchByKey = this.localAppliedSearchBy;
      const searchKeyword = this.appliedSearch;
      
      if (searchKeyword?.trim()) {
        this.$emit(eventName, {
          searchBy: searchKeyword?.trim() ? searchByKey : '', // 有關鍵字時才回傳searchBy
          keyword: searchKeyword?.trim()
        });

        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          const fetchFn = this.fetchAppliedList ;
          fetchFn(1); // 重設為第一頁
        }, 300);
      }
     
    },
    onSelectedAppliedChange(val) {
      this.localSelectedApplied = val;
      this.$emit('update:selectedApplied', val);
    },
    // onSelectedUnappliedChange(val) {
    //   this.localSelectedUnapplied = val;
    //   this.$emit('update:selectedUnapplied', val);
    // },
    setInitialSearchByOptions() {
      if (this.searchByOptions.length) {
        // 設定已套用列表的搜尋選項
        const defaultAppliedValue = this.appliedSearchBy || this.defaultSearchBy || this.searchByOptions[0].value;
        // 如果當前的 localAppliedSearchBy 不在新的 searchByOptions 中，或為空值，則重設
        if (!this.searchByOptions.some(option => option.value === this.localAppliedSearchBy) || !this.localAppliedSearchBy) {
          this.localAppliedSearchBy = defaultAppliedValue;
        }
      } else {
        // 如果沒有可用的 searchByOptions，則清空搜尋選項
        this.localAppliedSearchBy = "";
      }
    }
  }
};
</script>
